








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EmployeeCard extends Vue {
  @Prop({ type: Number, required: true }) dimension!: number;
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) image!: string;

  getImage() {
    return `https://cdn.planbook.com/images/planbook_team/${this.image}`;
  }
}
